/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Agent_Hub_About_Approvers_CountInputs */



/**
* | output |
* | --- |
* | "{count} chosen people" |
*
* @param {Agent_Hub_About_Approvers_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_hub_about_approvers_count = /** @type {((inputs: Agent_Hub_About_Approvers_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Hub_About_Approvers_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} ausgewählte Personen`)
	return /** @type {LocalizedString} */ (`${i?.count} chosen people`)
});